
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"11.818","viewBox":"0 0 13 11.818","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.344 7.09c.317 0 .601-.117.845-.362.252-.236.373-.52.373-.835 0-.307-.121-.583-.373-.811a1.182 1.182 0 00-1.69 0 1.065 1.065 0 00-.374.811c0 .315.122.6.374.835.243.245.528.363.845.363zm-1.99 1.97c-.383 0-.692-.188-.919-.41-.228-.22-.341-.511-.341-.866V4.058c0-.379.113-.67.341-.883.228-.213.536-.417.918-.417h4.38c.39 0 .698.204.926.417.227.213.341.504.341.883v3.726c0 .355-.114.646-.341.867-.228.22-.537.41-.927.41H7.354zM0 9.849V1.97C0 .882.91 0 2.031 0h9.246c.269 0 .512.102.716.307.203.197.308.426.308.678v.59h-5.16c-.657 0-1.21.505-1.64.923-.431.41-.626.93-.626 1.56v3.726c0 .623.195 1.143.626 1.552.43.418.983.906 1.64.906h5.16v.591c0 .26-.105.497-.309.694a.999.999 0 01-.715.291H2.031C.91 11.818 0 10.936 0 9.848z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    